import React from "react";
import "../modal.css";
import {RiCloseLine} from "react-icons/ri";

export default class CyberfaceModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            firstName: '',
            lastName: '',
            position: '', 
            cyberfaceUrl:'',
            loading: true,
        }
    }
    onClose = e => {
        this.setState({cyberfaceUrl : '',loading: true});
        this.props.onClose && this.props.onClose(e);
    };
    
    handleImageLoad = () => {
        
        console.log("images loaded");
        this.setState({loading: false});
    }


    render() {
       if (!this.props.isOpen) {
         return null;
       }

        let isLoading = this.state.loading
            ? <p><em className="cyberfaceLoad">Loading...</em></p>
            : "";
       
       return <div>
            <div className="darkBG"/>
            <div className="centered">
                <div className="cyberfaceModal">
                    <div className="modalHeader">
                        <h5 className="heading">Mvp Cyberface Texture</h5>
                    </div>
                    <button className="closeBtn" onClick={this.onClose}>
                        <RiCloseLine style={{marginBottom: "-3px"}}/>
                    </button>
                    <div className="modalContent">
                        <h3 className="cyberfaceHeader">Mvp Player
                            : { this.props.playerData.firstName + " " + this.props.playerData.lastName}
                        </h3>
                         
                        <div className="cyberfacePics">
                            {isLoading}
                            <div><img src={this.cyberfaceUrl} onLoad={this.handleImageLoad} alt="Player image"></img><div className="cyberfaceHash"></div></div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    }


}

